module.exports = __webpack_public_path__ + "img/loader-turquesa.70e99924.gif";